import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import SkillMap from './pages/SkillMap';
import Leaderboard from './pages/Leaderboard';
import Profile from './pages/Profile';
import Demo from './pages/Demo';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="map" element={<SkillMap />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="profile" element={<Profile />} />
          <Route path="demo" element={<Demo />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;